module.exports = __webpack_public_path__ + "img/toMy.c3c0cf07.png";